<nav class="flex flex-col w-52">
  <span class="mb-4 font-semibold">Settings</span>
  <ul
    class="flex flex-col w-full py-2 space-y-4 border-r border-gray-300">
    <li class="flex space-x-2">
      <span class="material-icons">vpn_key</span>
      <a
        href="clients"
        class="hover:text-gray-800">API Clients</a>
    </li>
    <li class="flex space-x-2">
      <span class="material-icons">description</span>
      <a
        href="templates"
        class="hover:text-gray-800">Templates</a>
    </li>
    <li class="flex space-x-2">
      <span class="material-icons">alternate_email</span>
      <a
        href="addresses"
        class="hover:text-gray-800">E-Mail Addresses</a>
    </li>
    <li class="flex space-x-2">
      <span class="material-icons">email</span>
      <a
        href="mails"
        class="hover:text-gray-800">Test E-Mail</a>
    </li>
  </ul>
</nav>
